import Reflux from 'reflux'
import LookupActions from '../actions/LookupActions'

var LookupReturnStore = Reflux.createStore(
{
	init:function(){this.listenTo(LookupActions.lookupReturn,'lookupReturn')},
    lookupReturn(_value,entityId,innerId)
    {
        //this.values.push(_value);
        if(typeof(_value) =='number')_value = _value+"";//TODO_YL 下拉返回 都是以String？
		this.trigger(_value,entityId,innerId);
    }
});

export default LookupReturnStore;


// WEBPACK FOOTER //
// ./src/stores/LookupReturnStore.js